import React from 'react';
import { ShieldCheck, Eye, Zap, Users, Headphones, ThumbsUp } from 'lucide-react';
import './about-main.css';
import teamImage from '../assets/images/about-us.png';

const values = [
  {
    icon: Eye,
    title: 'Transparency',
    text: 'Clear terms, honest rates, and open communication from application to repayment.',
  },
  {
    icon: Zap,
    title: 'Speed',
    text: 'A fully digital journey with quick reviews so you are not left waiting.',
  },
];

const stats = [
  { icon: Users, value: '1000+', label: 'Clients served' },
  { icon: Headphones, value: '24/7', label: 'Dedicated support' },
  { icon: ThumbsUp, value: '99%', label: 'Satisfaction rate' },
];

const AboutMain = () => {
  return (
    <section className="abt-section" aria-labelledby="abt-title">
      <div className="abt-bg" aria-hidden="true">
        <div className="abt-bg-gradient" />
        <div className="abt-bg-dots" />
        <span className="abt-bg-orb abt-bg-orb--1" />
        <span className="abt-bg-orb abt-bg-orb--2" />
      </div>

      <div className="abt-wrap">
        <div className="abt-shell">
          <figure className="abt-visual">
            <img src={teamImage} alt="" className="abt-visual-img" loading="eager" />
            <figcaption className="abt-visual-cap">
              <ShieldCheck size={16} aria-hidden />
              RBI-registered NBFC · Marathon Finlease · NBFC (B-14.01969)
            </figcaption>
          </figure>

          <div className="abt-panel">
            <header className="abt-head">
              <span className="abt-eyebrow">About us</span>
              <h1 id="abt-title" className="abt-title">
                Company overview
              </h1>
              <p className="abt-lead">
                Ultra Short Term Loans for salaried professionals — simple, regulated, and designed around
                your peace of mind.
              </p>
            </header>

            <div className="abt-block">
              <h2 className="abt-block-title">Company background</h2>
              <p className="abt-block-text">
                We work with Marathon Finlease, an RBI-registered NBFC (B-14.01969), to offer
                lending that is easy to apply for and easy to understand. Verification, approval,
                and disbursement follow strict compliance standards while staying fast and digital.
              </p>
            </div>

            <div className="abt-closing">
              <h2 className="abt-closing-title">Core values</h2>
              <div className="abt-values">
                {values.map(({ icon: Icon, title, text }) => (
                  <article key={title} className="abt-value">
                    <span className="abt-value-icon">
                      <Icon size={20} strokeWidth={2.2} aria-hidden />
                    </span>
                    <div className="abt-value-body">
                      <h3>{title}</h3>
                      <p>{text}</p>
                    </div>
                  </article>
                ))}
              </div>

              <ul className="abt-metrics" aria-label="Key figures">
                {stats.map(({ icon: Icon, value, label }) => (
                  <li key={label}>
                    <span className="abt-metric-icon">
                      <Icon size={18} aria-hidden />
                    </span>
                    <div className="abt-metric-text">
                      <strong>{value}</strong>
                      <span className="abt-metric-label">{label}</span>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutMain;
